import './userWithAvatar.css'
import React, { ComponentType, PropsWithChildren, ReactNode } from 'react'

interface IUserWithAvatarProps {
  name: string
  displayImage?: boolean
  displayName?: boolean
  children?: ReactNode
  nameElement?: ComponentType<PropsWithChildren> | null
}

const DefaultNameElement: React.FC<PropsWithChildren> = ({ children }) => {
  return <span className='user-name'>{children}</span>
}

function UserWithAvatar({ name, displayName = true, displayImage = true, nameElement, children }: IUserWithAvatarProps) {
  // @ts-ignore
  const initials = (name ?? '??')
    .match(/(^\S\S?|\s\S)?/g)
    .map((v) => v.trim())
    .join('')
    .match(/(^\S|\S$)?/g)
    .join('')
    .toLocaleUpperCase()

  const NameElement = nameElement ?? DefaultNameElement

  return (
    <div className='user-avatar'>
      {displayImage && <span className='user-img'>{initials}</span>}
      {displayName && <NameElement>{name}</NameElement>}
      {children}
    </div>
  )
}

export default UserWithAvatar
